function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgIconTeapot = function SvgIconTeapot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 11",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.66293C0.154895 2.39593 1.26211 2.17812 1.4629 2.28351C1.84428 2.61381 2.08467 3.00749 2.31919 3.39157C2.57855 3.81632 2.83073 4.22933 3.25854 4.53189C3.46507 4.1478 4.05596 3.27421 4.57802 3.00721C4.58152 3.00542 4.57834 2.98729 4.573 2.95692C4.54337 2.78839 4.44746 2.24273 5.05991 2.01652C5.50739 1.20851 6.45397 1.20851 6.45397 1.20851C6.45397 1.20851 6.06386 0.140524 6.56871 0H7.59561C7.69122 0.0398151 7.88245 0.192518 7.88245 0.484807C7.88245 0.581945 7.83105 0.777004 7.78747 0.942397C7.7554 1.06412 7.72755 1.16978 7.72755 1.20851C8.05456 1.26237 8.79346 1.46566 9.11014 2.01652C9.32049 2.04462 9.71595 2.27508 9.61498 2.97208L10.2001 3.49904C13.7513 -0.428598 16.4935 6.93485 10.4124 9.71723C10.1982 9.90693 9.64481 10.3201 9.23635 10.4831C9.24209 10.6259 9.20078 10.9173 8.89787 10.996H5.29513C5.18612 10.996 4.99681 10.8906 4.95665 10.4831C4.66407 10.3308 4.06744 9.99827 4.02154 9.88585C3.21456 9.51346 1.51683 7.92133 1.18179 4.53189C1.03681 3.84965 0.787783 3.58074 0.487037 3.25599C0.335581 3.09244 0.171008 2.91473 0 2.66293ZM11.2519 8.0763C11.4469 7.28468 11.6248 5.40213 10.7757 4.20487C10.9784 3.91679 11.5456 3.34626 12.1927 3.36875C13.0016 3.39685 13.3573 4.70372 13.0991 5.79981C12.9385 6.39704 12.1744 7.5929 11.2519 8.0763Z"
  }));
};
export default SvgIconTeapot;